module.exports = __webpack_public_path__ + "assets/img/teacher (30).588cf42b.png";